
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Editable from '@/mixins/Editable';
import VWrapper from '@/components/shared/VWrapper.vue';
import { namespace } from 'vuex-class';
import { Venue } from '@/interfaces/models/Venue';
import EditDepositRuleLoader from '@/components/depositRule/EditDepositRuleLoader.vue';
import DepositRuleForm from '@/components/depositRule/DepositRuleForm.vue';
import { DepositRule } from '@/interfaces/models/DepositRule';
import Notification from '@/mixins/Notification';

const venue = namespace('venue');
const depositRule = namespace('depositRule');

@Component({
  components: { DepositRuleForm, EditDepositRuleLoader, VWrapper },
})
export default class EditDepositRule extends mixins(Editable, Notification) {
  @venue.State('active') public venue!: Venue;

  @depositRule.Action('store') public store!: any;
  @depositRule.Action('update') public update!: any;
  @depositRule.Action('show') public show!: any;
  @depositRule.State('active') public active!: DepositRule;

  public $refs!: {
    form: InstanceType<typeof DepositRuleForm> & { getData: () => any; validate: () => Promise<boolean | boolean[]> };
  };

  get depositRule() {
    if (this.editing && this.active) {
      return this.active;
    }

    return null;
  }

  get title() {
    return this.editing ? 'depositRule.edit' : 'depositRule.create';
  }

  public async mounted() {
    if (this.editing) {
      this.$startLoading('depositRule');
      await this.show({ id: this.id });
      this.$stopLoading('depositRule');
    }
    if (this.editing && !this.active) {
      this.$router.push({ name: 'depositRule.index', query: { ...this.$route.query } });
    }
    if (!this.editing && !this.venue) {
      this.$router.push({ name: 'depositRule.index', query: { ...this.$route.query } });
    }
  }

  public save() {
    this.$refs.form.validate().then(async (res: boolean) => {
      if (res) {
        if (this.editing) {
          await this.update({ ...this.$refs.form.getData(), id: this.id });
        } else {
          await this.store({ ...this.$refs.form.getData(), venue: this.venue._id });
        }
        this.$router.push({ name: 'depositRule.index', query: { ...this.$route.query } });
      } else {
        this.notifyError('notification.form');
      }
    });
  }
}
